/*
 * appointment (schema)
 */
import { boolean, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { schema } from "../constants"
import { practitioners } from "../practitioner/practitioner.schema"
import { patients } from "../patient/patient.schema"
import { practitionerAvailabilities } from "../practitioner-availability/practitioner-availability.schema"
import { users } from "../user/user.schema"

export const appointments = schema.table("appointments", {
	id: uuid("id").primaryKey().notNull().defaultRandom(),

	// --- Relations ---
	practitionerId: uuid("practitioner_id")
		.notNull()
		.references(() => practitioners.id, { onDelete: "restrict" }),
	patientId: uuid("patient_id").references(() => patients.id, {
		onDelete: "set null",
	}),
	availabilityId: uuid("availability_id").references(
		() => practitionerAvailabilities.id,
		{ onDelete: "set null" },
	),

	// --- Time ---
	startsAt: timestamp("starts_at", { withTimezone: true }).notNull(),
	endsAt: timestamp("ends_at", { withTimezone: true }).notNull(),
	timezone: varchar("timezone", { length: 64 }).notNull().default("UTC"),

	// --- Details ---
	type: varchar("type", { length: 64 }),
	status: varchar("status", { length: 32 }).notNull().default("scheduled"),
	reason: varchar("reason", { length: 512 }),
	notes: text("notes"),

	// --- System ---
	active: boolean("active").notNull().default(true),
	createdAt: timestamp("created_at", { withTimezone: true })
		.notNull()
		.defaultNow(),
	updatedAt: timestamp("updated_at", { withTimezone: true })
		.notNull()
		.defaultNow(),
	createdBy: uuid("created_by").references(() => users.id, {
		onDelete: "set null",
	}),
	updatedBy: uuid("updated_by").references(() => users.id, {
		onDelete: "set null",
	}),
})
